import * as React from 'react';
import classnames from 'classnames';
import Base, { Props as BaseProps, TypeColors } from '../Base/Base';
import './Divider.css';

export interface Props extends BaseProps {
  /** Color of the dividing line. Any of the palette colors is acceptable */
  color: TypeColors;
  /**
   * Direction of the line. A fixed height or used as a flex child would be
   * ideal for the vertical direction.
   */
  direction?: 'horizontal' | 'vertical';
  /** Width of the dividing line. */
  width?: string;
  /** Type of the dividing line that is drawn */
  type?: 'dashed' | 'dotted' | 'solid';
}

/** A quick way to draw a line between something. */
const Divider: React.FunctionComponent<Props> = (props: Props) => {
  const { color, direction, type, width, ...rest } = props;
  const classes = classnames('Divider', `Divider--type-${type}`, {
    'Divider--vertical': direction === 'vertical',
  });

  const style = {
    ...rest.style,
    [direction === 'horizontal' ? 'borderTopWidth' : 'borderRightWidth']: width,
  };

  return (
    <Base { ...rest }
        Component="hr"
        className={ classes }
        style={ style }
        textColor={ color } />
  );
};

Divider.defaultProps = {
  direction: 'horizontal',
  type: 'solid',
  width: '0.125rem',
};

export default Divider;
